import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// -------------------- Modal Confirmation Reason Dialog --------------------
class Id {
  private constructor() {}

  public static readonly prefix = 'UI.webmodule-common.other.ui.ModalConfirmationReason.';
  public static readonly availableReasons = `${Id.prefix}availableReasons`;
  public static readonly reason = `${Id.prefix}reason`;
  public static readonly confirm = `${Id.prefix}confirm`;
  public static readonly comments = `${Id.prefix}comments`;
  public static readonly cancel = `${Id.prefix}cancel`;
  public static readonly pleaseSelectValidReason = `${Id.prefix}pleaseSelectValidReason`;
  public static readonly pleaseProvideCommentOther = `${Id.prefix}pleaseProvideCommentOther`;
  public static readonly other = `${Id.prefix}other`;
  public static readonly commentTooLong = `${Id.prefix}commentTooLong`;
  public static readonly select = `${Id.prefix}select`;
  public static readonly pleaseSelectReasonOption = `${Id.prefix}pleaseSelectReasonOption`; // New key
}

export class LangModalConfirmationReason {
  private constructor() {}

  public static availableReasons(): string {
    return interpolate(Id.availableReasons);
  }

  public static reason(): string {
    return interpolate(Id.reason);
  }

  public static confirm(): string {
    return interpolate(Id.confirm);
  }

  public static comments(): string {
    return interpolate(Id.comments);
  }

  public static cancel(): string {
    return interpolate(Id.cancel);
  }

  public static pleaseSelectValidReason(): string {
    return interpolate(Id.pleaseSelectValidReason);
  }

  public static pleaseProvideCommentOther(other: string): string {
    return interpolate(Id.pleaseProvideCommentOther, { other });
  }

  public static other(): string {
    return interpolate(Id.other);
  }

  public static commentTooLong(max: number, current: number): string {
    return interpolate(Id.commentTooLong, { max, current });
  }

  public static select(): string {
    return interpolate(Id.select);
  }

  public static pleaseSelectReasonOption(): string {
    // New method
    return interpolate(Id.pleaseSelectReasonOption);
  }
}

export class ModalConfirmationReasonModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.availableReasons, 'Available Reasons', 'Modal title: available reasons');
    register.add(Id.reason, 'Reason', 'Label: reason');
    register.add(Id.confirm, 'Confirm', 'Button: confirm');
    register.add(Id.comments, 'Comments', 'Label: comments');
    register.add(Id.cancel, 'Cancel', 'Button: cancel');
    register.add(Id.pleaseSelectValidReason, 'Please select a valid reason', 'Validation: select a valid reason');
    register.add(
      Id.pleaseProvideCommentOther,
      "Please provide a comment when selecting '{{other}}' as the reason.",
      'Validation: provide comment for Other'
    );
    register.add(Id.other, 'Other', 'Reason: Other');
    register.add(
      Id.commentTooLong,
      'Comment is too long. Maximum length is {{max}} ({{current}} currently)',
      'Validation: comment too long'
    );
    register.add(Id.select, 'Select', 'Button: select');
    register.add(Id.pleaseSelectReasonOption, 'Please select a reason', 'Dropdown: please select option'); // New registration
  }
}
